<script lang="ts">
	import { goto } from '$app/navigation';
	import { resolve } from '$app/paths';
	import { Button } from '@ui-components/ui/button';
	import CoreFooter from './CoreFooter.svelte';

	interface Props {
		isMinimal?: boolean;
		signInHandler: () => void;
		signUpHandler: () => void;
	}
	let { signInHandler, signUpHandler, isMinimal = false }: Props = $props();
</script>

<footer
	class="w-full dark pt-12 md:pt-16 pb-0 bg-gray-900 flex flex-col justify-start items-center gap-8 md:gap-10 overflow-hidden"
>
	<div class="w-full">
		<CoreFooter {signInHandler} {signUpHandler} />
	</div>
</footer>
